import React from 'react';
import ReactDOM from 'react-dom/client';
import './design/tokens.css';
import './design/shell.css';
import './design/app.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
